export const ADD_INGREDIENT = 'ADD_INGREDIENT';
export const REMOVE_INGREDIENT = 'REMOVE_INGREDIENT';
export const SET_INGREDIENT = 'SET_INGREDIENT';
export const FETCH_FAILED = 'FETCH_FAILED';

export const PURCHASED_SUCCESS = 'PURCHASED_SUCCESS';
export const PURCHASED_FAILED = 'PURCHASED_FAILED';
